import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1afba43c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding-top":"10px"} }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  class: "ss-foto-pessoa",
  style: {"background-color":"transparent"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "REMOVER", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "ss-foto-pessoa" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ENVIAR", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_18 = {
  key: 0,
  class: "ant-skeleton ant-skeleton-active css-eq3tly"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-skeleton-content" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "ant-skeleton-paragraph" }, [
    /*#__PURE__*/_createElementVNode("li")
  ])
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_25 = { class: "ant-row" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-separador" }
const _hoisted_29 = { class: "ant-row" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_31 = { class: "ant-row" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_cidade = _resolveComponent("selecionar-cidade")!
  const _component_selecionar_categoria_cnh = _resolveComponent("selecionar-categoria-cnh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_form_item, {
          label: "",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            (_ctx.computedFoto)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (_ctx.state.carregandoFoto)
                      ? (_openBlock(), _createBlock(_component_a_spin, {
                          key: 0,
                          size: "large"
                        }))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.computedFoto,
                          alt: "Foto"
                        }, null, 8, _hoisted_6))
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removerFoto && _ctx.removerFoto(...args))),
                    type: "button",
                    disabled: _ctx.state.carregandoFoto,
                    class: "ant-btn ant-btn-sm ant-btn-primary ant-btn-dangerous ss-btn-foto-pessoa"
                  }, _hoisted_9, 8, _hoisted_7)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.state.carregandoFoto)
                      ? (_openBlock(), _createBlock(_component_a_spin, {
                          key: 0,
                          size: "large"
                        }))
                      : (_openBlock(), _createBlock(_component_icone, {
                          key: 1,
                          style: {"font-size":"30px","color":"#8d8d8d"},
                          nome: "foto"
                        }))
                  ]),
                  _createVNode(_component_a_upload, {
                    "file-list": _ctx.state.listaArquivo,
                    "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.listaArquivo) = $event)),
                    "show-upload-list": false,
                    multiple: false,
                    accept: 'image/*',
                    "before-upload": _ctx.enviarFoto
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        disabled: _ctx.state.carregandoFoto,
                        class: "ant-btn ant-btn-sm ant-btn-primary ss-btn-foto-pessoa"
                      }, _hoisted_14, 8, _hoisted_12)
                    ]),
                    _: 1
                  }, 8, ["file-list", "before-upload"])
                ]))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_a_form_item, {
              label: "Estado civil",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                (_ctx.state.carregandoEstadoCivil)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                  : (_openBlock(), _createBlock(_component_a_select, {
                      key: 1,
                      class: "ss-tamanho-completo",
                      value: _ctx.computedEstadoCivil,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedEstadoCivil) = $event)),
                      placeholder: "Selecione",
                      options: _ctx.state.listaEstadoCivil
                    }, null, 8, ["value", "options"]))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_a_form_item, {
              label: "Número Identidade/RG",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "20",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedRg) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.computedRg]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_a_form_item, {
              label: "Órgão emissor",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "10",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedOrgaoEmissor) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.computedOrgaoEmissor]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_a_form_item, {
              label: "Data de nascimento",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_data, {
                  dataSelecionada: _ctx.computedDataNascimento,
                  "onUpdate:dataSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedDataNascimento) = $event))
                }, null, 8, ["dataSelecionada"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_a_form_item, {
              label: "Cidade nascimento",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_cidade, {
                  codigoSelecionado: _ctx.computedCodigoCidadeNascimento,
                  "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.computedCodigoCidadeNascimento) = $event)),
                  apresentarEstado: true
                }, null, 8, ["codigoSelecionado"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_a_form_item, {
              label: "Nome da mãe",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "250",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedNomePai) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.computedNomePai]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_a_form_item, {
              label: "Nome do pai",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "250",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.computedNomeMae) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.computedNomeMae]
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_a_form_item, {
              label: "CNH",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  maxlength: "30",
                  class: "ant-input",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.computedCnh) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.computedCnh]
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_a_form_item, {
              label: "Categoria",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_categoria_cnh, {
                  codigoSelecionado: _ctx.computedCategoriaCnh,
                  "onUpdate:codigoSelecionado": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedCategoriaCnh) = $event))
                }, null, 8, ["codigoSelecionado"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_a_form_item, {
              label: "Vencimento CNH",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_data, {
                  dataSelecionada: _ctx.computedDataVencimentoCnh,
                  "onUpdate:dataSelecionada": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.computedDataVencimentoCnh) = $event))
                }, null, 8, ["dataSelecionada"])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}